import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchDashboardData } from "../../../features/dashboard/services/dashboardService";

export const getDashboardData = createAsyncThunk(
  "dashboard/getDashboardData",
  async ({ period, dateRange }, thunkAPI) => {
    const response = await fetchDashboardData(period, dateRange);
    // ✅ Extract payload from response if it exists
    return response.payload || response.data || response;
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    loading: false,
    error: null,
    data: null,
    period: "monthly", // <-- set default here
    dateRange: null, // { startDate, endDate }
  },
  reducers: {
    setPeriod(state, action) {
      state.period = action.payload;
    },
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDashboardData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { setPeriod, setDateRange } = dashboardSlice.actions;
export default dashboardSlice.reducer;